// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/CommentComposeBubble.test.tsx
import { createContext } from "react";

/**
 * The new-comment box's "Send to Puntt" switch. A surface that can hand a new
 * comment to the chat provides it; without a provider the box shows no switch.
 */
export type ComposeSendToPuntt = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

// why a context: the box is drawn deep inside AssetViewerPane, which every
// review surface shares, and only the V2 review has a chat to send to.
export const ComposeSendToPunttContext =
  createContext<ComposeSendToPuntt | null>(null);
